var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramDigiWallet40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.309804 0 0 0 0 0.298039 0 0 0 0 0.301961 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DigitalWallet40",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(11.000000, 8.500000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 14,
    height: 17
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFCC00",
    points: "0 16 14 16 13.3273926 22.5480957 0.634521484 22.5480957"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14,4.26538086 L14,3 C14,1.34314575 12.6568542,-3.04359188e-16 11,0 L3,0 C1.34314575,3.04359188e-16 -2.02906125e-16,1.34314575 0,3 L0,20 C2.02906125e-16,21.6568542 1.34314575,23 3,23 L11,23 C12.6568542,23 14,21.6568542 14,20 L14,16.4793759 L14,16.4793759 L0.326171875,16.4793759",
    id: "Path-2",
    stroke: "#979797"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D8D8D8",
    cx: 7,
    cy: 20,
    r: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(15.792893, 10.500000) rotate(-315.000000) translate(-15.792893, -10.500000) translate(11.792893, 6.500000)",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,6.5 C8,2.91014913 5.08985087,-2.84217094e-14 1.5,-2.84217094e-14",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.29289322,7.20710678 C5.29289322,4.72182541 3.27817459,2.70710678 0.792893219,2.70710678",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.58578644,7.91421356 C2.58578644,6.53350169 1.46649831,5.41421356 0.0857864376,5.41421356",
    id: "Path"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramDigiWallet40);
export default __webpack_public_path__ + "static/media/pictogramDigiWallet40.2c9a46427b60de305fcf91a3df39c23e.svg";
export { ForwardRef as ReactComponent };